import React from 'react';

import ReactDOM from 'react-dom';

export default class Alimentation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      active: false,
      pristine: true,
      values: [],
      alimentation_type: []
    };
  }

  componentDidMount = () => {
    document.addEventListener(
      'click',
      this.handleClickOutside.bind(this),
      true
    );
  };

  componentWillReceiveProps = nextProps => {
    //alimentations
    if (this.state.pristine && nextProps.alimentations.length) {
      const alimentation_type = nextProps.boards
        ? nextProps.boards.split(',')
        : [];

      this.setState({
        values: nextProps.alimentations,
        alimentation_type,
        pristine: false
      });
    }
  };

  componentWillUnmount = () => {
    document.removeEventListener(
      'click',
      this.handleClickOutside.bind(this),
      true
    );
  };

  render = () => {
    return (
      <div
        className={
          'alimentation_type select-wrapper animated-text-form extended ' +
          (this.state.active ? 'active' : '')
        }
        ref={() => {
          this.returnSearchedValue = this.returnSearchedValue.bind(this);
        }}
      >
        <ul className="dropdown-wrapper">{this.renderCheckboxes()}</ul>
      </div>
    );
  };

  handleClickOutside = event => {
    const domNode = ReactDOM.findDOMNode(this);
    if ((!domNode || !domNode.contains(event.target)) && this.state.active) {
      this.setState({ active: false });
    }
  };

  handleChange = event => {
    let alimentation_type = this.state.alimentation_type;
    if (alimentation_type.indexOf(event.target.value) > -1) {
      alimentation_type = alimentation_type.filter(
        alimentation => alimentation !== event.target.value
      );
    } else {
      alimentation_type.push(event.target.value);
    }
    this.setState({ alimentation_type });
  };

  handleClose = () => this.setState({ active: false });

  handleFocus = () => this.setState({ active: true });

  renderCheckboxes = () =>
    this.state.values.map((alimentation, i) => {
      const isChecked =
        this.state.alimentation_type.indexOf(`${alimentation.id}`) > -1;
      return (
        <li key={`alimentation_type ${i}`} className="item">
          <input
            type="checkbox"
            id={`alimentation_type_${alimentation.id}`}
            name="alimentation"
            onChange={this.handleChange}
            value={alimentation.id}
            checked={isChecked}
          />
          <label htmlFor={`alimentation_type_${alimentation.id}`}>
            {alimentation.name}
          </label>
        </li>
      );
    });

  returnSearchedValue = () => {
    return this.state.alimentation_type.length
      ? this.state.alimentation_type
      : false;
  };
}



// WEBPACK FOOTER //
// ./app/javascript/common/components/alimentation.js